import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {DiSearchSelectFormlessComponent} from 'app/common/di-search-select-formless/di-search-select-formless.component';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzTooltipModule} from 'ng-zorro-antd/tooltip';
import {NzIconModule} from 'ng-zorro-antd/icon';

@NgModule({
    declarations: [DiSearchSelectFormlessComponent],
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        NzSelectModule,
        NzFormModule,
        NzTooltipModule,
        NzIconModule
    ],
    exports: [DiSearchSelectFormlessComponent],
    providers: []
})
export class DiSearchSelectFormlessModule {}
